import React from "react"
import News from "../../blocks/news"
import { graphql } from "gatsby"

export const pageQuery = graphql`
query {
  news: newsYaml(slug: { eq: "saveljevs_mantova" }) {
    ...NewsInfo
  }
}`

export default class NewsText extends News {
  renderNews() {
    return (
      <div className="row">
        <div className="col-xl-12">
          <p>Полузащитник сборной Латвии Алексейс Савельевс подписал контракт на один год с футбольным клубом Мантова 1911. Мантова 1911 проведёт этот сезон в итальянской серии С. Catenaccio поздравляет Алексейса и желает ему удачи в новом клубе!</p>
        </div>
      </div>
    )
  }
}